import { Descriptions } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

export const ShowInventory = ({ inventory }) => {
  const { t } = useTranslation("dashboard");
  return inventory?.map((inv, idx) => (
    <Descriptions
      key={idx}
      className="mt-4"
      title={inv?.item?.itemName}
      bordered
      size="middle"
      column={{ xs: 1, sm: 1, md: 2 }}
    >
      <Descriptions.Item key={inv.item._id} label={t("Total")}>
        {inv.total}
      </Descriptions.Item>
      <Descriptions.Item key={inv.item._id} label={t("Used")}>
        {inv?.used}
      </Descriptions.Item>
      <Descriptions.Item key={inv.item._id} label={t("Available")}>
        {inv?.total - inv?.used}
      </Descriptions.Item>
    </Descriptions>
  ));
};
